import { create } from "zustand";

export const useAppStore = create((set) => ({
  filteredPopups: [],
  setFilteredPopups: (filteredPopups) => set({ filteredPopups }),
  cartFilteredPopups: [],
  setCartFilteredPopups: (cartFilteredPopups) => set({ cartFilteredPopups }),
  cartPopupTrigger: 0,
  triggerCartPopup: () => set((s) => ({ cartPopupTrigger: s.cartPopupTrigger + 1 })),
  promoPopupVisible: false,
  setPromoPopupVisible: (promoPopupVisible) => set({ promoPopupVisible }),
}));
